<template>
  <div class="mt-5 pt-lg-5 term-wrap">
    <b-container class="mb-5 pb-lg-3">
      <template v-if="content">
        <content-header :title="content.title" />
        <div class="mt-5">
          <!-- <p class="text-14 text-md-16">
            {{ content.content }}
          </p> -->
          <p class="text-14 text-md-16 term-content" v-html="content.content" />
        </div>
      </template>
      <template v-else>
        <div class="py-5 text-center">
          <b-spinner small variant="platform" />
        </div>
      </template>
    </b-container>
  </div>
</template>

<script>
import MiddleContainer from "@/components/platform/MiddleContainer";
import ContentHeader from "@/components/platform/ContentHeader";
export default {
  components: {
    MiddleContainer,
    ContentHeader,
  },
  data() {
    return {
      content: null,
    };
  },
  computed: {
    type() {
      return this.$route.query.type;
    },
  },
  watch: {
    type(n) {
      // 약관 type을 새로 불러올때마다 reset
      this.content = null;
      this.getTypes(n);
    },
  },
  mounted() {
    // console.log( this.$route.query.type ) ; 
    // console.log( this.type ) ; 


    // 적절한 type으로 접근하는지 확인
    this.getTypes(this.type);
  },
  methods: {
    // 약관 타입 불러오기
    async getTypes(type = "") {
      const types = await this.$wApi.terms.types();
      // console.log({ types , type }) ; 
      // console.log( types[ type ] , types.includes ) ; 
      // if (types && types.includes(type)) {
      if (types && types.hasOwnProperty( type ) ) {
        this.getRecent(type); // 약관 최신 불러오기
      } else {
        // 타입이 맞지 않은 약관 불러올경우
        const bool = await window.alert("잘못된 접근입니다.", { title: "알림", okVariant: "platform" });
        if (bool) this.$router.go(-1);
      }
    },
    // 약관 최신 불러오기
    async getRecent(type = "") {
      const data = await this.$wApi.terms.get({ type });
      if (data) this.content = data;
    },
  },
};
</script>

<style lang="scss" scoped>
  .term-wrap{
    display:flex;
    justify-content: center;
  }
</style>
<style lang="scss">
  .term-content{
    table{
      padding:5px;
      td{
        padding:10px;
        border:1px solid #ddd;
      }
    }
  }
</style>
